import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fortawesome/fontawesome-free/css/all.min.css";

// Global fetch interceptor to handle 401 Unauthorized application-wide
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const [resource] = args;
  const url = typeof resource === 'string' ? resource : resource instanceof URL ? resource.href : resource?.url;

  const response = await originalFetch(...args);

  // If 401 and it's not a login request, clear token and redirect
  if (response.status === 401 && url && !url.includes('/auth/login')) {
    localStorage.removeItem("authToken");
    window.location.href = "/login";
  }

  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
